import { callAsync } from "./officeAsync";

/**
 * The subject, attachment names and the start of the body as one string for keyword matching.
 * Only the start of the body is read so quoted reply history doesn't cause false matches.
 * Any read that fails contributes nothing (fail open, FR-19).
 */
export async function getContentText(item: Office.MessageCompose, maxBodyChars: number): Promise<string> {
  try {
    const [subject, body, attachments] = await Promise.all([
      callAsync<string>((cb) => item.subject.getAsync(cb)),
      callAsync<string>((cb) => item.body.getAsync(Office.CoercionType.Text, cb)),
      callAsync<Office.AttachmentDetailsCompose[]>((cb) => item.getAttachmentsAsync(cb)),
    ]);
    const attachmentNames = (attachments ?? []).map((a) => a.name);
    return [subject ?? "", ...attachmentNames, (body ?? "").slice(0, maxBodyChars)].join("\n");
  } catch {
    return "";
  }
}
